import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

type Reason = "not-verified" | "incomplete-profile" | "no-full-trustap";

interface ModalProps {
  show: boolean;
  onHide: () => void;
  // Default action — the existing call sites use this for "go to
  // verification". Newer call sites pass `reason` and we route to the
  // right destination via the right callback.
  onSuccess: () => void;
  // Optional, defaults to "not-verified" so existing usages keep working.
  reason?: Reason;
  // Called when reason is "incomplete-profile". Falls back to onSuccess
  // if not provided (backward compatible).
  onCompleteProfile?: () => void;
  // Called when reason is "no-full-trustap". Falls back to onSuccess if
  // not provided.
  onSetUpTrustap?: () => void;
}

const COPY: Record<Reason, { title: string; body: string; cta: string }> = {
  "not-verified": {
    title: "Get Verified",
    body: "You need to get verified before you can create a listing. Please verify your account to continue.",
    cta: "Get Verified",
  },
  "incomplete-profile": {
    title: "Complete your profile",
    body: "Your profile is missing some details we need before you can list an artwork — including address, phone, date of birth, and speciality.",
    cta: "Complete profile",
  },
  "no-full-trustap": {
    title: "Set up your Trustap account",
    body: "You need a full Trustap account before you can list an artwork — it's how we pay you when an item sells. A guest account is not enough.",
    cta: "Set up Trustap",
  },
};

const GetVerifiedFirst: React.FC<ModalProps> = ({
  show,
  onHide,
  onSuccess,
  reason = "not-verified",
  onCompleteProfile,
  onSetUpTrustap,
}) => {
  const { title, body, cta } = COPY[reason];
  const handleAction =
    reason === "incomplete-profile" && onCompleteProfile
      ? onCompleteProfile
      : reason === "no-full-trustap" && onSetUpTrustap
      ? onSetUpTrustap
      : onSuccess;

  return (
    <Modal
      className="disputeModal txt-user-cnic-picture"
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="text-start">
        <div className="d-flex justify-content-between">
          <h5>{title}</h5>
          <img
            src="/assets/imgs/plus.svg"
            style={{ cursor: "pointer" }}
            onClick={onHide}
            alt=""
          />
        </div>
        <hr />

        <div className="mb-1 pb-2">{body}</div>

        <div className="d-flex gap-2 justify-content-end mt-3">
          <Button
            className="closeBtn"
            style={{ width: "120px" }}
            onClick={onHide}
          >
            Close
          </Button>
          <button
            className="mainBtn"
            style={{ width: "140px" }}
            onClick={handleAction}
          >
            {cta}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default GetVerifiedFirst;
